import { Breadcrumbs, Link as MuiLink } from "@mui/material";
import type { FC } from "react";
import { constructBreadcrumbs, type TreeViewItem } from "../utils";

export const FolderBreadcrumb: FC<{
  treeItems: TreeViewItem[];
  selectedTreeItemId: string | null;
  onFolderSelect: (folderId: string) => void;
}> = ({ treeItems, selectedTreeItemId, onFolderSelect }) => {
  const breadcrumbs = constructBreadcrumbs(treeItems, selectedTreeItemId);

  return (
    <Breadcrumbs separator="/">
      {breadcrumbs.map((breadcrumb, index) => (
        <MuiLink
          key={breadcrumb.id}
          component="button"
          underline="none"
          onClick={() => onFolderSelect(breadcrumb.id)}
          sx={{ cursor: "pointer" }}
          {...(index === 0 ? { color: "primary.main" } : { color: "inherit" })}
        >
          {breadcrumb.label}
        </MuiLink>
      ))}
    </Breadcrumbs>
  );
};
